var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2250(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2250",
    "data-name": "Group 2250",
    transform: "translate(-1000 -768)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1422",
    "data-name": "Ellipse 1422",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(1000 768)",
    fill: "#36c4ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-calendar",
    "data-name": "Icon ionic-md-calendar",
    d: "M19.042,14.449H14.45v4.592h4.592ZM17.511,4.5V6.031H9.858V4.5h-2.3V6.031H6.413A1.919,1.919,0,0,0,4.5,7.944V20.955a1.919,1.919,0,0,0,1.913,1.913H20.955a1.919,1.919,0,0,0,1.913-1.913V7.944a1.919,1.919,0,0,0-1.913-1.913H19.807V4.5Zm3.444,16.455H6.413V10.814H20.955Z",
    transform: "translate(1005.816 773.816)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2250);
export default __webpack_public_path__ + "static/media/Group 2250.e0064b142ceb85b61f174bec45315521.svg";
export { ForwardRef as ReactComponent };